import React, { memo } from "react";
import classNames from "classnames";
import { MdStar } from "react-icons/md";
import { Rate } from "../../types/business.types";
import useTranslation from "next-translate/useTranslation";

type Props = {
  rate: Rate;
  textClassName?: string;
};

function RateBadge({ rate, textClassName }: Props) {
  const { score, count } = rate || {};
  const { t } = useTranslation("common");

  return count && count > 0 ? (
    <div
      className={classNames(
        "flex items-center space-x-1 text-sm",
        textClassName
      )}
    >
      <MdStar className="relative -top-[1px] w-4 h-4" />
      <span>{score}</span>
    </div>
  ) : (
    <span>{t(`global.noreview`)}</span>
  );
}

export default memo(RateBadge);
